
import React, { Fragment } from 'react'
import get from 'lodash/get'
import { DownloadButton, Page, Text, Table } from '@fielded/shared-ui'
import { OUTBOUND_TEMPLATE_COLUMNS } from '@fielded/fs-api/lib/shipment/constants'
import ExportImportCard from '../../../../../van-shared/components/ExportImportCard/ExportImportCard'
import { COLUMNS, ROWS } from './utils'

const PSMShipmentExportImportDownload = ({
  warehouseCode,
  facilitiesExamples = [],
  productExamples = [],
  country,
  app,
  isExcelTemplateDownloading,
  handleExcelTemplateDownload
}) => {
  const rows = get(ROWS, [app, country], ROWS['default'])

  // Decorating rows with real data for the warehouse
  const decoratedRows = rows.map((row, index) => {
    if (warehouseCode) {
      row.originWarehouseCode = warehouseCode
    }

    if (productExamples && productExamples.length > 0) {
      row.productCode = get(productExamples[index], '_id', '')
      row.productName = get(productExamples[index], 'fullName', '')
    }

    if (facilitiesExamples[index]) {
      row.destinationWarehouseCode = get(facilitiesExamples[index], 'additionalData.warehouseCode', row.destinationWarehouseCode)
      row.destinationWarehouseName = get(facilitiesExamples[index], 'name', '')
    }
    return row
  })

  return (
    <Fragment>
      <Page.Panel>
        <ExportImportCard
          title='Download shipment template'
          description='To upload your shipment details, please use an Excel file in the correct format. You can download the shipment template below to guide you on how the file should be structured. Make sure not to modify the structure of the template to avoid upload errors. Here is an example how the excel file should look:'
        >

          <Text>Here is an example how the Excel file should look:</Text>
          <div className='inbound-shipments-upload-example__wrapper vs-u-margin-bottom'>
            <Table
              entries={decoratedRows}
              columns={COLUMNS}
              headerTextStyle='lowercase'
            />
          </div>

          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_NAME} - </Text> The <Text tag='span' bold>name of a destination (e.g. facility)</Text> where the product is being delivered to.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.DESTINATION_WAREHOUSE_CODE} - </Text> The <Text tag='span' bold>warehouse code</Text> of the location <Text tag='span' bold>receiving the shipment</Text>. This can be a central, regional, or state warehouse, a pack point, or any service delivery point such as a hospital, health center, or pharmacy.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.PRODUCT_NAME} - </Text> The name of the product being shipped.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.PRODUCT_CODE} - </Text> The code of the product being shipped.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.QUANTITY} - </Text> The <Text tag='span' bold>amount of product</Text> to be delivered.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.ORIGIN_WAREHOUSE_CODE} - </Text> The <Text tag='span' bold>warehouse code</Text> of the location <Text tag='span' bold>sending the shipment</Text>. This can be a central, regional, or state warehouse, or a pack point.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.EXTERNAL_ID} - </Text> A reference ID used to <Text tag='span' bold>track the shipment</Text> in the customer’s internal tracking system or ERP.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.DATE} - </Text> The <Text tag='span' bold>shipment date</Text> in the format "dd-mm-yyyy" or "dd/mm/yyyy".</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.BATCH_NO} - </Text> The <Text tag='span' bold>batch number</Text> of the product.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.MANUFACTURER} - </Text> The <Text tag='span' bold>name of the manufacturer</Text> of the product.</Text>
          <Text><Text tag='span' bold>{OUTBOUND_TEMPLATE_COLUMNS.EXPIRY} - </Text> The <Text tag='span' bold>expiry date</Text> of the product, in the format "dd-mm-yyyy" or "dd/mm/yyyy"</Text>
        </ExportImportCard>
      </Page.Panel>
      <Page.Footer fixed>
        <DownloadButton
          size='regular'
          isProminent
          onClick={handleExcelTemplateDownload}
          disabled={isExcelTemplateDownloading}
        >
          {isExcelTemplateDownloading ? 'Downloading' : 'Download Excel Template'}
        </DownloadButton>
      </Page.Footer>
    </Fragment>
  )
}

export default PSMShipmentExportImportDownload
